import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SearchModule } from 'app/layout/common/search/search.module';
import { IncidenciaBadgeComponent } from 'app/layout/common/incidencia-badge/incidencia-badge.component';
import { RecetaBadgeComponent } from 'app/layout/common/receta-badge/receta-badge.component';

import { ClassyLayoutComponent } from 'app/layout/layouts/vertical/classy/classy.component';

@NgModule({
    imports: [
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        SearchModule,
        IncidenciaBadgeComponent,
        RecetaBadgeComponent,
        ClassyLayoutComponent,
    ],
    exports: [
        ClassyLayoutComponent,
    ],
})
export class ClassyLayoutModule {
}
